<template>
  <div>
    <div class="spinStyle" v-if="loading" :style="spinHeight ? { height: spinHeight + 'px' } : ''">
      <a-spin tip="Loading..." v-if="loading"></a-spin>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // spinStyle: {
      //   width: '375px',
      //   height: '100%',
      //   display: 'flex',
      //   'justify-content': 'center',
      //   'align-items': 'center',
      //   'z-index': 999
      // }
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    spinHeight: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="stylus" scoped>
.spinStyle {
  width: 375px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
</style>
